import theme from '@/common/styles/mui-theme';

const authFooterStyles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(8),
    px: theme.spacing(6),
    py: theme.spacing(8),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
};

export default authFooterStyles;
